<template>
  <div class="container-customer-service">
    <div class="back"></div>
  </div>
</template>
<script>
import Client from '@/assets/scripts/client'

export default {
  data() {
    const query = this.$route.query
    return {
      autoSendContent: query.autoSendContent || null,
    }
  },
  created() {
    if (this.autoSendContent && this.autoSendContent != null) {
      this.sendData()
    }
  },
  mounted() {
    ssq.push('chatOpen')
  },
  methods: {
    // 上传数据
    sendData() {
      const app = Client.getAppInfo()
      ssq.push('setLoginInfo', {
        // 加密后的用户 id, 必填
        user_id: app.presentId,
        // 用户名， 必填
        user_name: app.nickname,
        // 插件语言， 选填
        language: app.language,
        // 邮箱， 选填
        email: app.email,
      })
    },

    // 打开对话框
    open() {
      ssq.push('chatOpen')
    },
  },
  destroyed() {
    ssq.push('chatClose')
  },
}
</script>

<style lang="scss">
.container-customer-service {
  position: relative;
}
</style>
